// @ts-nocheck

import { Room, Client, getStateCallbacks} from "colyseus.js";
import { State } from "../server/schemas/State";
import { fetchProjData, Point, projData } from "./Utility";
// import { createInterpolator } from 'svg-path-interpolator';

// import * as bootstrap from 'bootstrap'
import Two from "two.js";
import { getRenderer, fetchGraphics, ChoiceModal, Viewport, offsetTime, UsernameModal } from "./Renderer";
import { Lobby } from "./Lobby";
export const ENDPOINT = "https://ca-yto-b4dea50b.colyseus.cloud";
// export const ENDPOINT = "http://localhost:2567";
const WORLD_SIZEX = 1000;
const WORLD_SIZEY = 500;


export class Application{
    client = new Client(ENDPOINT);
    lobby: Lobby

    room: Room<State>;

    heldKeys: Set<string> = new Set([]);
    heldButtons: number = 0;

    entities: {[id: string]: any} = {};
    entityUpdate: {[id: string]: any} = {};
    entityAdd: {[id: string]: any} = {};
    lastTime: number
    currentPlayerEntity;
    loaded: boolean;
    disable: boolean;
    respawn;
    
    viewport: Viewport;
    choiceModal: ChoiceModal

    hud
    modalQueue = [];

    settingRoom = false;
    latency = 0;
    onLatencyUpdate;

    constructor(){
        this.viewport = new Viewport(500, 500)
        this.initialize()
    }

    async initialize(){
        await fetchGraphics(this.viewport)
        await fetchProjData()
        this.lobby = new Lobby(this)
        // await this.connect()
    }

    postInit(){

        // setInterval(() => this.ping(), 500)

        this.choiceModal = new ChoiceModal(document.getElementById('choiceModal'), this);
        this.choiceModal.buttonCallback = ((i) => {this.room.send('requestselec', {selection: i})})

        // this.usernameModal = new UsernameModal(document.getElementById('usernameModal'), this);
        // this.usernameModal.submitCallback = ((e) => {this.room.send('username', {username: e})})

        this.viewport.renderer.domElement.style.backgroundColor = 'rgba(0, 0, 0, 1)'; 
        this.lastTime = performance.now()

        this.hud = document.querySelector('#levelUpHUD')

        this.viewport.bind('update', this.update.bind(this))
        this.viewport.play()

        this.viewport.renderer.domElement.addEventListener("mousemove", (e) => {
            if (this.currentPlayerEntity) {
                this.room.send('mousemove', this.viewport.toLocal(e.offsetX, e.offsetY));
            }
        });

        this.viewport.renderer.domElement.addEventListener("mousedown", (e) => {
            if (this.currentPlayerEntity) {
                this.room.send('mousebutton', {buttons: e.buttons});
                this.heldButtons = e.buttons
            }
        });

        this.viewport.renderer.domElement.addEventListener("mouseup", (e) => {
            if (this.currentPlayerEntity) {
                this.room.send('mousebutton', {buttons: e.buttons});
                this.heldButtons = e.buttons
            }
        });

        let _this = this
        document.addEventListener('keydown', function(e) {
            if (_this.disable){
                return
            }
            if (!_this.heldKeys.has(e.key.toLowerCase())){
                _this.heldKeys.add(e.key.toLowerCase())
                if (e.key.toLowerCase() == 'e'){
                    _this.room.send('requestlevel');
                }
                if (_this.currentPlayerEntity){
                    _this.room.send('keydown', {key: e.key})
                }
            }
        });
        
        document.addEventListener('keyup', function(e) {
            if (_this.disable){
                return
            }
            if (_this.heldKeys.has(e.key.toLowerCase())){
                if (_this.currentPlayerEntity){
                    _this.heldKeys.delete(e.key.toLowerCase())
                    // _this.currentPlayerEntity.update(1)
                    _this.room.send('keyup', {key: e.key})
                }
            }
        });
    }

    update (_, dt){
        Object.entries(this.entities).forEach(([_, e]) => {
            e.update(dt)
        });
    }

    async ping(){
        this.room.send('ping', {clock: Date.now()})
    }

    async setRoom(roomId?){
        if (this.settingRoom){
            return
        }
        this.settingRoom = true
        
        if (roomId){
            this.room = await this.client.joinById<State>(roomId, {username: this.lobby.getUsername(), weapons: this.lobby.weapons})
        }
        else{
            this.room = await this.client.create<State>('my_room', {username: this.lobby.getUsername(), weapons: this.lobby.weapons})
        }
        document.querySelector('#lobby').classList.add('d-none')
        console.log('CLIENT SESSION ID', this.client.sessionId)
        await this.connectRoom()
        await this.postInit()
    }

    async connectRoom() {
        const $ = getStateCallbacks(this.room);

        this.room.onMessage('wh', (m) => {
            this.viewport.setBase(m.width, m.height)
        })

        this.room.onMessage('pong', (m) => {
            this.latency = ((Date.now() - m.clock) - m.delay) / 2
            this?.onLatencyUpdate()
        })

        $(this.room.state).entities.onAdd((entity, sessionId: string) => {
            console.log(`Entity[${sessionId}] of type ${entity.entityType} =`, entity)
            var graphics = getRenderer(entity, this.room.state)
            graphics.addToView(this.viewport)
            this.entities[entity.entityID] = graphics;

            if (sessionId === this.room.sessionId) {
                if (!this.currentPlayerEntity){
                    // CHANGE THIS
                    $(entity).listen('respawnTime', (cur, prev) => {
                        if (this.respawn){
                            this.viewport.remove(this.respawn)
                        }
                        this.respawn = new Two.Text(`YOU DIED\nRespawn in ${cur}`, this.viewport.width / 2, this.viewport.height / 2, {fill: '#FFFFFF'})
                        if (cur > 0){
                            this.viewport.add(this.respawn)
                        }
                    })
                }
                this.currentPlayerEntity = graphics;
            }
            if (entity.entityType == 'player'){
                $(entity).listen('username', (cur, last) => {
                    if (!last){
                        graphics.usernameGroup.add(new Two.Text(cur, 0, 0, {fill: '#FFFFFF', size: 10, family: 'monospace'}))
                    }
                })
            }
            $(entity).onChange(() => {
                this.entityUpdate[entity.entityID] = performance.now();
                if (entity.entityID in this.entities){
                    this.entities[entity.entityID].updateEntity()
                    // this.entities[entity.entityID].update() //?
                }
            })
        });

        $(this.room.state).entities.onRemove((entity, sessionId: string) => {
            console.log('DELETE', entity.entityID)
            setTimeout(() => {
                this.entities[entity.entityID].removeFromView(this.viewport)
                delete this.entities[entity.entityID];
                delete this.entityUpdate[entity.entityID]
                this.viewport.update()
            }, 0.5*(this.entities[entity.entityID].state.time - this.entities[entity.entityID].estServerTime))

        });
    }
}